import React from 'react';
import { iconProps } from '../Helper';

const PasswordIcon = ({ className }: iconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <mask
        id="mask0_5023_45502"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5023_45502)">
        <path
          className={className}
          d="M10.7405 14.75H13.2595L12.6943 11.5922C13.0083 11.4575 13.2611 11.2464 13.4528 10.9587C13.6444 10.6709 13.7402 10.3513 13.7402 9.99995C13.7402 9.52045 13.5701 9.11054 13.2298 8.7702C12.8894 8.42987 12.4795 8.2597 12 8.2597C11.5205 8.2597 11.1106 8.42987 10.7702 8.7702C10.4299 9.11054 10.2598 9.52045 10.2598 9.99995C10.2598 10.3513 10.3556 10.6709 10.5473 10.9587C10.7389 11.2464 10.9918 11.4575 11.3058 11.5922L10.7405 14.75ZM12 21.4807C9.83717 20.8909 8.0465 19.6178 6.628 17.6615C5.20933 15.7051 4.5 13.518 4.5 11.1V5.3462L12 2.53845L19.5 5.3462V11.1C19.5 13.518 18.7907 15.7051 17.372 17.6615C15.9535 19.6178 14.1628 20.8909 12 21.4807ZM12 19.9C13.7333 19.35 15.1667 18.25 16.3 16.6C17.4333 14.95 18 13.1166 18 11.1V6.37495L12 4.13445L6 6.37495V11.1C6 13.1166 6.56667 14.95 7.7 16.6C8.83333 18.25 10.2667 19.35 12 19.9Z"
          fill="white"
        />
      </g>
    </svg>
  );
};

export default PasswordIcon;
